export default __webpack_public_path__ + "7f0ee58032ae7e39e4814c34043e6f26.png";